import { NetworkStatus } from '@cbridge-utils/network';
import { IMarkupStore } from './markup.interface';

export const markupInitialState: IMarkupStore = {
  data: {},
  networkStatus: NetworkStatus.None,
  filteredCount: 0,
  totalCount: 0,
};
